import React from "react";
import "./FooterTop.scss";

import Wrapper from "../../Common/Wrapper";
import FooterInfo from "./FooterInfo/FooterInfo";
import ContactForm from "../../Form/ContactForm/ContactForm";

const FooterTop = ({ themeOptions }) => {
    return (
        <div className="footer--top">
            <Wrapper>
                <div className="footer--top__inside">
                    <div className="footer--top__inside--left">
                        <FooterInfo themeOptions={themeOptions} />
                    </div>
                    <div className="footer--top__inside--right">
                        <ContactForm />
                    </div>
                </div>
            </Wrapper>
        </div>
    );
};

export default FooterTop;
